module.exports = __webpack_public_path__ + "img/GFilm2.2bc9abeb.png";